import React from "react";
import { useNavigate } from "react-router-dom";
import { handleSmartBack } from "../../../../utils/navigationHelper";

const BackButton = ({ fallbackPath = "/" }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    handleSmartBack(navigate, fallbackPath);
  };

  return (
    <>
      <p onClick={handleBack} className="backlink">
        <i className="fa-solid fa-angle-left"></i> Back
      </p>
    </>
  );
};

export default BackButton;
